<template>
  <RouterView />
  <EditContentDialog />
</template>

<style scoped></style>
<script setup lang="ts">
import { SESSION_EXPIRED_EVENT } from '@/constants/authEvents'
import { useUserStore } from '@/stores/userStore'
import EditContentDialog from '@/views/_layout/forms/EditContentDialog.vue'
import { onMounted, onUnmounted } from 'vue'

const userStore = useUserStore()

const onSessionExpired = (event: Event) => {
  const customEvent = event as CustomEvent<{ redirectPath?: string }>
  void userStore.handleSessionExpired(customEvent.detail?.redirectPath)
}

onMounted(() => {
  window.addEventListener(SESSION_EXPIRED_EVENT, onSessionExpired)
})

onUnmounted(() => {
  window.removeEventListener(SESSION_EXPIRED_EVENT, onSessionExpired)
})
</script>
